import React, { useEffect, useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Spinner, FormGroup, Label, Input } from 'reactstrap';

import { ValidatedForm, ValidatedField } from 'react-jhipster';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { fetchFeedbackQuestions, saveMeetingFeedback } from 'app/entities/meeting/meeting-feedback.reducer';

const FeedbackModal = ({ meetingId, isOpen, mentorId, toggle }) => {
  const dispatch = useAppDispatch();

  const { questions = [], loading = false, updating = false, updateSuccess } = useAppSelector(state => state.meetingFeedback) || {};

  const [selectedIds, setSelectedIds] = useState<number[]>([]);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [questionError, setQuestionError] = useState<String>('');
  const [questionComments, setQuestionComments] = useState({});
  const [commentErrors, setCommentErrors] = useState({});
  const allFeedbackShared = questions.length > 0 && questions.every(q => q?.isShareFeedBack);
  useEffect(() => {
    if (isOpen && meetingId && mentorId) {
      dispatch(fetchFeedbackQuestions({ meetingId, mentorId }));
    }
  }, [isOpen, meetingId, mentorId]);

  useEffect(() => {
    if (isOpen) {
      setSelectedIds([]);
      setFormSubmitted(false);
      setQuestionComments({});
      setCommentErrors({});
      setQuestionError('');
    }
  }, [isOpen]);

  useEffect(() => {
    if (updateSuccess) {
      setFormSubmitted(true);

      const timer = setTimeout(() => {
        toggle();
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, [updateSuccess]);

  const handleCommentChange = (id, value) => {
    setQuestionComments(prev => ({
      ...prev,
      [id]: value,
    }));

    setCommentErrors(prev => ({
      ...prev,
      [id]: '',
    }));
  };

  const handleCheckboxChange = (id: number) => {
    setQuestionError('');
    setSelectedIds(prev => (prev.includes(id) ? prev.filter(q => q !== id) : [...prev, id]));
  };

  const saveEntity = () => {
    let isValid = true;

    if (selectedIds.length === 0) {
      setQuestionError('Please select at least one option');
      isValid = false;
    }

    const feedBacks: any = [];

    const errors = {};

    selectedIds.forEach(id => {
      const comment: any = questionComments[id]?.trim();

      if (!comment) {
        errors[id] = 'Please enter feedback';
        isValid = false;
      } else {
        feedBacks.push({
          questionId: id,
          feedBack: comment,
        });
      }
    });

    setCommentErrors(errors);

    if (!isValid) return;

    dispatch(
      saveMeetingFeedback({
        meetingId,
        mentorId,
        feedBacks,
      })
    );
  };

  return (
    <Modal className="provide-feedback" isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Give Feedback</ModalHeader>

      <ModalBody>
        {formSubmitted ? (
          <div className="alert alert-success">Feedback Submitted Successfully.</div>
        ) : loading ? (
          <Spinner />
        ) : (
          <FormGroup>
            <Label className="fw-bold">
              Select Feedback <span className="text-danger">*</span>
            </Label>
            <div className="select-ul">
              {questions.length > 0 ? (
                questions.map(q => (
                  <div key={q.id} className="mb-3">
                    <div className="d-flex align-items-center">
                      <Input
                        type="checkbox"
                        checked={selectedIds.includes(q.id) || q?.isShareFeedBack}
                        onChange={() => handleCheckboxChange(q.id)}
                        disabled={q?.isShareFeedBack}
                      />

                      <Label className="ms-2 mb-0">{q.question?.charAt(0).toUpperCase() + q.question?.slice(1)}</Label>
                    </div>

                    {q.feedBack && (
                      <div
                        className="mt-2 ms-1 px-3 py-2 rounded-3"
                        style={{
                          background: '#f8f9fa',
                          fontSize: '14px',
                          color: '#495057',
                          lineHeight: '1.5',
                        }}
                      >
                        <span className="fw-bold">Feedback:</span> {q.feedBack}
                      </div>
                    )}

                    {selectedIds.includes(q.id) && !q?.isShareFeedBack && (
                      <FormGroup className="mt-3 ms-4">
                        <Label className="fw-semibold">
                          Feedback <span className="text-danger">*</span>
                        </Label>

                        <Input
                          type="textarea"
                          rows="3"
                          placeholder="Enter feedback..."
                          value={questionComments[q.id] || ''}
                          onChange={e => handleCommentChange(q.id, e.target.value)}
                        />

                        {commentErrors[q.id] && <div className="text-danger mt-1">{commentErrors[q.id]}</div>}
                      </FormGroup>
                    )}
                  </div>
                ))
              ) : (
                <p>No questions found</p>
              )}
            </div>

            {questionError && <div className="text-danger mt-1">{questionError}</div>}
          </FormGroup>
        )}
      </ModalBody>

      {!formSubmitted && (
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>

          <Button color="primary" onClick={saveEntity} disabled={updating || allFeedbackShared}>
            {updating ? 'Saving...' : 'Submit'}
          </Button>
        </ModalFooter>
      )}
    </Modal>
  );
};

export default FeedbackModal;
